import { Component } from "react";
import { Box, Button, Typography } from "@mui/material";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "60vh",
          px: 4,
          textAlign: "center",
        }}
      >
        <Typography fontSize={56} sx={{ mb: 2, lineHeight: 1 }}>😵</Typography>
        <Typography variant="h6" fontWeight={700} color="#374151" sx={{ mb: 1 }}>
          Something broke
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4, maxWidth: 380, lineHeight: 1.7 }}>
          The page ran into an unexpected error. Try refreshing — if it keeps happening, let us know.
        </Typography>
        <Button
          onClick={() => {
            this.setState({ hasError: false });
            window.location.href = "/feed";
          }}
          variant="contained"
          sx={{ bgcolor: "#046287", "&:hover": { bgcolor: "#035070" }, borderRadius: 2, fontWeight: 700 }}
        >
          Back to home
        </Button>
      </Box>
    );
  }
}

export default ErrorBoundary;
